import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "@/components/feature/HeroSection";
import LatestNews from "@/components/feature/LatestNews";
import MostReadCommented from "@/components/feature/MostReadCommented";
import BotafogoTV from "@/components/feature/BotafogoTV";
import AoVivoHighlight from "@/components/feature/AoVivoHighlight";
import Patrocinadores from "@/components/feature/Patrocinadores";
import AdBanner from "@/components/feature/AdBanner";
import { useAnalytics } from "@/hooks/useAnalytics";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function Home() {
  useAnalytics("/");
  usePageSeo({
    title: "Central Alvinegra | Noticias do Botafogo, SAF, FogaoNet e Mercado da Bola",
    description: "Noticias do Botafogo, SAF, FogaoNet, mercado da bola, Brasileirao, Copa do Mundo, Danilo, Garrincha, jogos e Botafogo TV.",
    keywords: "Botafogo, FogaoNet, SAF Botafogo, Copa do Mundo, Danilo, Garrincha, Mercado da Bola, Brasileirao, Botafogo TV",
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="bg-white">
        <HeroSection />
      </div>

      <div className="w-full px-4 md:px-8">
        <AdBanner variant="leaderboard" label="Publicidade" />
      </div>

      <LatestNews />

      <div className="w-full px-4 md:px-8">
        <AdBanner variant="leaderboard" label="Publicidade" />
      </div>

      <MostReadCommented />

      <BotafogoTV />

      <AoVivoHighlight />

      <div className="w-full px-4 md:px-8">
        <AdBanner variant="medium-rectangle" label="Publicidade" />
      </div>

      <Patrocinadores />

      <Footer />
    </div>
  );
}
